import { render, staticRenderFns } from "./ads-iframe.vue?vue&type=template&id=fba23202&scoped=true&"
import script from "./ads-iframe.vue?vue&type=script&lang=js&"
export * from "./ads-iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba23202",
  null
  
)

export default component.exports